import React, { useEffect, useState } from "react";
import { useDeal } from "../lib/store";
import { RoomSetup, useRoomShare } from "../components/ShareRoomModal";
import { RoomActivityCard } from "../components/room/RoomActivityCard";
import { QAManager } from "../components/room/QA";
import { shareApi } from "../lib/api";
import { Globe } from "lucide-react";

export default function DealRoom() {
  const { M } = useDeal();
  const { share, setShare, loaded } = useRoomShare();
  const [view, setView] = useState("setup");
  const [refreshKey, setRefreshKey] = useState(0);
  const [openQ, setOpenQ] = useState(0);
  useEffect(() => { if (share) shareApi.activity(share.id).then((a) => setOpenQ(a.openQuestions || 0)).catch(() => {}); }, [share?.id, refreshKey, view]);

  return (
    <div className="page" data-testid="page-dealroom">
      <div className="page-head" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
        <div>
          <div className="page-title"><Globe size={18} style={{ marginRight: 8, verticalAlign: "-3px" }} />Deal Room — {M.dealName}</div>
          <div className="page-sub">Passcode-gated Web CIM for investors: pick the tabs, set the ask and timeline, upload documents, then publish. Personal links per investor are optional. Track who opened it, what they read, and soft commitments.</div>
        </div>
        {share && <a className="btn btn-share" href={share.roomUrl || `${window.location.origin}/room/${share.id}`} target="_blank" rel="noreferrer" data-testid="dr-open-room">Open live room ↗</a>}
      </div>
      <div className="dr-tabs" data-testid="dr-tabs">
        <button className={view === "setup" ? "active" : ""} onClick={() => setView("setup")} data-testid="dr-tab-setup">Setup & Publish</button>
        <button className={view === "activity" ? "active" : ""} onClick={() => { setView("activity"); setRefreshKey((k) => k + 1); }} data-testid="dr-tab-activity">Raise & Activity</button>
        <button className={view === "qa" ? "active" : ""} onClick={() => setView("qa")} data-testid="dr-tab-qa">Q&A{openQ > 0 && <span className="dr-badge" data-testid="dr-qa-badge">{openQ}</span>}</button>
      </div>
      {!loaded ? <div className="bullet">Loading…</div>
        : view === "setup" ? <RoomSetup share={share} setShare={setShare} onPublished={() => setRefreshKey((k) => k + 1)} />
        : view === "activity" ? <RoomActivityCard refreshKey={refreshKey} onShare={() => setView("setup")} />
        : share ? <QAManager share={share} onChange={() => setRefreshKey((k) => k + 1)} /> : <div className="bullet">Publish the room first.</div>}
    </div>
  );
}
